import { Component, OnInit } from '@angular/core';
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
@Component({
  selector: 'app-norm35-step10',
  templateUrl: './norm35-step10.component.html',
  styleUrls: ['./norm35-step10.component.scss']
})
export class Norm35Step10Component implements OnInit {
  dataLink = [
    {
      name  : '10.1 Este procedimiento para la evaluación de la conformidad aplica tanto',
      ruta : 'step10-sub1'
    },{
      name  : '10.2 Los aspectos a verificar durante la evaluación de la conformidad de la presente Norma se realizarán ',
      ruta : 'step10-sub2'
     },{
      name  : '10.3 Para la selección de trabajadores por entrevistar por parte de la autoridad laboral y/o las unidades de verificación',
      ruta : 'step10-sub3'
     },{
      name  : '10.4 Las evidencias de tipo documental o los registros a que alude esta Norma podrán exhibirse',
      ruta : 'step10-sub4'
    },
  ]
  idiomaBanner:any;
  private _unsubscribeAll: Subject<any>;
  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService
  ) {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaBanner(this.translateSrv.currentLang); });
   }

  ngOnInit() {
    this.cambiaIdiomaBanner(this.translateSrv.currentLang);
  }
  cambiaIdiomaBanner(idioma:string){
    this.idiomaBanner = this.translateSrv.currentLang; 
    switch(idioma){
      case 'es': this.idiomaBanner = idioma; 
      break;
      default: this.idiomaBanner = 'en';
    }
    this.getBanner();
  }
  urlBanner:any;
  getBanner(){
    this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-20.png';
  }

  

}
